/* eslint-disable no-void */
import * as vp from 'vopay';

import { FunctionComponent, useContext } from 'react';

import AccountsContext from '../AccountContext';
import CredentialsPanel from '../../UI/CredentialsPanel';

type AccountCredentialsPanelProps = {
  accountId: string;
};

type FC = FunctionComponent<AccountCredentialsPanelProps>;

const AccountCredentialsPanel: FC = ({ accountId }: AccountCredentialsPanelProps) => {
  const { details } = useContext(AccountsContext);
  const credentials = getCredentials(details[accountId].token);

  function getCredentials(token: string): vp.EncodedCredentials {
    const json = vp.parseJWT(token);
    const defaults = { AccountID: '', ApiKey: '', ApiSharedSecret: '' };

    return isEncodedCredentials(json) ? json : defaults;
  }

  function isEncodedCredentials(json: JSON | vp.EncodedCredentials): json is vp.EncodedCredentials {
    const hasAccountID = Object.prototype.hasOwnProperty.call(json, 'AccountID');
    const hasApiKey = Object.prototype.hasOwnProperty.call(json, 'ApiKey');
    const hasApiSharedSecret = Object.prototype.hasOwnProperty.call(json, 'ApiSharedSecret');

    return hasAccountID && hasApiKey && hasApiSharedSecret;
  }

  return <CredentialsPanel credentials={credentials} />;
};

export default AccountCredentialsPanel;
